import './data-container.sass';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ChartsContainer from 'components/supervision/charts-container/ChartsContainer';
import Physics from 'components/supervision/physics/Physics';
import Events from 'components/supervision/events/Events';
import Binary from 'components/supervision/binary/Binary';
import VoiceStreams from 'components/supervision/voice-streams/VoiceStreams';

import bindMercureTopic from 'actions/bindMercureTopic';

class DataContainer extends Component {
  componentDidMount() {
    if (this.props.sessionActive === true) {
      this.subscribe(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.sessionActive === true) {
      this.subscribe(nextProps);
    }
  }

  componentWillUnmount() {
    if (this._source) {
      this._source.close();
      this._source = null;
    }
  }

  subscribe(props) {
    if (!props.uid || this._subscribedUid === props.uid) {
      return;
    }
    if (this._source) {
      this._source.close();
    }
    this._subscribedUid = props.uid;
    this._source = props.bindMercureTopic({
      uid: props.uid,
      topic: 'supervision/' + props.uid,
      mercureUrl: MERCURE_URL,
      reducerEvent: 'RECEIVED_SUPERVISION_NEW_DATA'
    });
  }

  render() {
    return (
      <div className='supervision-data-container'>
        <div className='supervision-data-container__output'>
          <div className='supervision-data-container__charts'>
            <ChartsContainer/>
          </div>
          <div className='supervision-data-container__events'>
            <Events/>
          </div>
          <div className='supervision-data-container__params'>
            <Physics/>
          </div>
          <div className='supervision-data-container__binary'>
            <Binary/>
          </div>
          <div className='supervision-data-container__voice'>
            <VoiceStreams/>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    sessionActive: state.supervisionData.status,
    uid: ownProps.uid,
    errorCode: state.supervisionData.errorCode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bindMercureTopic: bindActionCreators(bindMercureTopic, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DataContainer);
